<div class="tooltip-dialog mat-elevation-z6">
  <div class="header">
    <div class="header-left">
      <mat-icon class="header-icon">info</mat-icon>
      <h3 class="header-title">{{ 'Information' | translate }}</h3>
    </div>
    <div class="header-right">
        <button mat-icon-button aria-label="Close" class="close-btn" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
    </div>
  </div>

  <ng-container *ngIf="items">
    <nav mat-tab-nav-bar class="tabs-fixed" aria-label="Tooltip tabs">
      <a mat-tab-link *ngFor="let it of items; let i = index" [active]="i === activeIndex" (click)="selectIndex(i)">
        {{ it.label || ('Tooltip ' + (i+1)) }}
      </a>
    </nav>
  </ng-container>

  <div class="content">
    <ng-container *ngIf="items; else single">
      <div class="tab-content">
        <div class="text" *ngIf="items[activeIndex]?.text">{{ items[activeIndex].text }}</div>

        <div class="video-wrapper" *ngIf="items[activeIndex]?.youtube_video">
          <div class="video" [class.loading]="loading">
            <div class="spinner" *ngIf="loading">
              <mat-spinner diameter="36"></mat-spinner>
            </div>
            <iframe [src]="safeVideoUrl" frameborder="0" (load)="onVideoLoaded()" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #single>
      <div class="text" *ngIf="singleText">{{ singleText }}</div>

      <div class="video-wrapper" *ngIf="singleVideo">
        <div class="video">
          <div class="spinner" *ngIf="loading">
            <mat-spinner diameter="36"></mat-spinner>
          </div>
          <iframe [src]="safeVideoUrl" frameborder="0" (load)="onVideoLoaded()" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="actions">
    <button mat-flat-button color="primary" (click)="close()">{{ 'Got It' | translate }}</button>
  </div>
</div>
